import axios from "axios";

export const AFILIADO_URL = `AfiliadoSempre`;

export const afiliadoSempreServices = {
  getById: (id: string) => {
    return axios.get<any>(`${AFILIADO_URL}/${id}`);
  },
  lookup: (queryParams: any) => {
    return axios.get<any>(`${AFILIADO_URL}/Lookup`, {
      params: {
        ...queryParams,
      },
    });
  },
};
